/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { FsxVolumeBackupInfo } from '../models/FsxVolumeBackupInfo';

/**
* FSx snapshot properties for native AWS Backup snapshots.
*/
export class FsxSnapshotProperties {
  /**
  * AWS Backup recovery point ARN (primary for file systems, or first volume for ONTAP).
  */
  'recoveryPointArn'?: string;
  /**
  * AWS Backup vault name where the backup is stored.
  */
  'backupVaultName'?: string;
  /**
  * AWS region where the backup is stored.
  */
  'region'?: string;
  /**
  * AWS account ID where the backup is stored.
  */
  'sourceAccountId'?: string;
  /**
  * For ONTAP file systems, the list of recovery point ARNs for each volume backup.
  */
  'volumeBackupArns'?: Array<string>;
  /**
  * Details of volumes that were backed up in this snapshot.
  */
  'backedUpVolumes'?: Array<FsxVolumeBackupInfo>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "recoveryPointArn",
      "baseName": "recoveryPointArn",
      "type": "string",
      "format": ""
    },
    {
      "name": "backupVaultName",
      "baseName": "backupVaultName",
      "type": "string",
      "format": ""
    },
    {
      "name": "region",
      "baseName": "region",
      "type": "string",
      "format": ""
    },
    {
      "name": "sourceAccountId",
      "baseName": "sourceAccountId",
      "type": "string",
      "format": ""
    },
    {
      "name": "volumeBackupArns",
      "baseName": "volumeBackupArns",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "backedUpVolumes",
      "baseName": "backedUpVolumes",
      "type": "Array<FsxVolumeBackupInfo>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return FsxSnapshotProperties.attributeTypeMap;
  }

  public constructor() {
  }
}

